export class AccessCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "condition",
            "baseName": "condition",
            "type": "Condition",
            "format": ""
        },
        {
            "name": "effect",
            "baseName": "effect",
            "type": "AccessConditionEffect",
            "format": ""
        },
        {
            "name": "expression",
            "baseName": "expression",
            "type": "AccessConditionalExpression",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AccessCondition.attributeTypeMap;
    }
    constructor() {
    }
}
